import { BonusHistory, OccBonusHistorySearchParams } from '@my-account/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BONUS_HISTORY } from '../my-account-state';

export const LOAD_BONUS_HISTORY = '[CustomUser] Load bonus history';
export const LOAD_BONUS_HISTORY_FAIL = '[CustomUser] Load bonus history Fail';
export const LOAD_BONUS_HISTORY_SUCCESS = '[CustomUser] Load bonus history Success';
export const SET_BONUS_HISTORY = '[CustomUser] Set balance history';
export const LOAD_BONUS_HISTORY_RESET = '[CustomUser] Load bonus history reset';
export class LoadBonusHistory extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BONUS_HISTORY;

  constructor(public payload?: OccBonusHistorySearchParams) {
    super(BONUS_HISTORY);
  }
}

export class LoadBonusHistoryFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BONUS_HISTORY_FAIL;

  constructor() {
    super(BONUS_HISTORY);
  }
}

export class LoadBonusHistorySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BONUS_HISTORY_SUCCESS;

  constructor(public payload: BonusHistory) {
    super(BONUS_HISTORY);
  }
}

export class LoadBonusHistoryReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BONUS_HISTORY_RESET;

  constructor() {
    super(BONUS_HISTORY);
  }
}

export class SetBonusHistory implements Action {
  readonly type = SET_BONUS_HISTORY;

  constructor() {}
}
export type BonusBalanceActions =
  | LoadBonusHistory
  | LoadBonusHistorySuccess
  | LoadBonusHistoryFail
  | SetBonusHistory
  | LoadBonusHistoryReset;
